import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { SelectableObjectModel } from '../../model/selectable-object.model';

/**
 * * Componente de Árvore selecionável.
 */
@Component({
  selector: 'ui-generic-select-tree',
  templateUrl: './generic-select-tree.component.html',
  styleUrls: ['./generic-select-tree.component.scss']
})
export class GenericSelectTreeComponent implements OnInit {

  @Input()
  list: SelectableObjectModel[] = [];

  @Input()
  title: string = '';

  @Input()
  placeholderText = '';

  @Input()
  icon: any;

  @Input()
  showOptions: boolean = true;

  selectedlist: SelectableObjectModel[] = [];

  @Output() textValuelista = new EventEmitter<any>();
  @Output() oc = new EventEmitter<any>();

  onValue(value: SelectableObjectModel) {
    value.selected = false;

    // Deseleciona da lista
    const filter = this.list.filter(item => item.id === value.id);
    filter[0].selected = false;
    this.selectedlist = this.selectedlist.filter(item => item.id !== value.id);
    this.textValuelista.emit(this.selectedlist);
  }

  changeOptions() {
    // console.log(this.showOptions);
   this.showOptions = !this.showOptions;
    this.oc.emit(this.showOptions);
  }

  constructor() { }

  ngOnInit() {
    this.selectedlist = [];
  }

  onSelect(event: any, item: SelectableObjectModel) {
    this.oc.emit(this.showOptions);
    if (event.target.id === 'conectado-select') {
      if (this.selectedlist.includes(item)) {
        item.selected = false;
        this.selectedlist = this.selectedlist.filter(selected => selected.id !== item.id);
        this.textValuelista.emit(this.selectedlist);
      } else {
        item.selected = true;
        this.selectedlist.push(item);
        this.textValuelista.emit(this.selectedlist);
      }
    }
  }
}
